module.exports = __webpack_public_path__ + "media/images/icon-contents-menu-c815be7a67e2b9a531afdffeb0496823.svg";